import {
	GET_APPLICATIONS,
	GET_APPLICATIONS_SUCCESS,
	GET_APPLICATIONS_FAILURE,
	IOutreachConnectPayload,
	CONNECT_OUTREACH,
	CONNECT_OUTREACH_SUCCESS,
	CONNECT_OUTREACH_FAILURE,
	SEND_CODE_OUTREACH,
	DISCONNECT_APP,
	DISCONNECT_APP_SUCCESS,
	DISCONNECT_APP_FAILURE,
	IIntercomConnectPayload,
	CONNECT_INTERCOM,
	CONNECT_GONG,
	IGongConnectPayload,
	CONNECT_INTERCOM_SUCCESS,
	CONNECT_INTERCOM_FAILURE,
	CONNECT_GONG_SUCCESS,
	CONNECT_GONG_FAILURE,
	IZendeskConnectPayload,
	CONNECT_ZENDESK,
	CONNECT_ZENDESK_SUCCESS,
	CONNECT_ZENDESK_FAILURE,
} from './types';

export const getApplicationsAction = () => ({
	type: GET_APPLICATIONS,
});

export const getApplicationsSuccessAction = (payload: any) => ({
	type: GET_APPLICATIONS_SUCCESS,
	payload,
});

export const getApplicationsFailureAction = (error: Error) => ({
	type: GET_APPLICATIONS_FAILURE,
	payload: error,
});

export const connectOutreachAction = (payload: IOutreachConnectPayload) => ({
	type: CONNECT_OUTREACH,
	payload,
});

export const connectOutreachSuccessAction = () => ({
	type: CONNECT_OUTREACH_SUCCESS,
});

export const connectOutreachFailureAction = (error: Error) => ({
	type: CONNECT_OUTREACH_FAILURE,
	payload: error,
});

export const connectIntercomAction = (payload: IIntercomConnectPayload) => ({
	type: CONNECT_INTERCOM,
	payload,
});

export const connectIntercomSuccessAction = () => ({
	type: CONNECT_INTERCOM_SUCCESS,
});

export const connectIntercomFailureAction = (error: Error) => ({
	type: CONNECT_INTERCOM_FAILURE,
	payload: error,
});

export const connectGongAction = (payload: IGongConnectPayload) => ({
	type: CONNECT_GONG,
	payload,
});

export const connectZendeskAction = (payload: IZendeskConnectPayload) => ({
	type: CONNECT_ZENDESK,
	payload,
});

export const connectZendeskSuccessAction = () => ({
	type: CONNECT_ZENDESK_SUCCESS,
});

export const connectZendeskFailureAction = (error: Error) => ({
	type: CONNECT_ZENDESK_FAILURE,
	payload: error,
});

export const connectGongSuccessAction = () => ({
	type: CONNECT_GONG_SUCCESS,
});

export const connectGongFailureAction = (error: Error) => ({
	type: CONNECT_GONG_FAILURE,
	payload: error,
});

export const disconnectAppAction = (payload: any) => ({
	type: DISCONNECT_APP,
	payload,
});

export const disconnectAppSuccessAction = (payload: string) => ({
	type: DISCONNECT_APP_SUCCESS,
	payload,
});

export const disconnectAppFailureAction = (error: Error) => ({
	type: DISCONNECT_APP_FAILURE,
	payload: error,
});

export const sendCodeOutreachAction = (payload: string) => ({
	type: SEND_CODE_OUTREACH,
	payload,
});
